import { CATEGORY_FILTERS_OPTIONS } from '@scalefast/core';
/**
 * Adapters should not be used in the store.
 * https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/600
 *
 * @deprecated
 */
export const CategoryPagePaginationFiltersAdapter = {
  buildPartialFiltersFromPagination: page => {
    return {
      offset: page
    };
  },
  buildPartialFiltersFromPageSize(pageSize) {
    return {
      pageSize: pageSize,
      offset: CATEGORY_FILTERS_OPTIONS.DEFAULT_PAGE_OFFSET
    };
  }
};
export const CategoryPageCriteriaFiltersAdapter = {
  buildPartialFiltersFromMultiSelect(filter) {
    return {
      filters: [filter],
      offset: CATEGORY_FILTERS_OPTIONS.DEFAULT_PAGE_OFFSET
    };
  }
};
